import { boundApiRequest } from '@/restapi/restapi.base.js';


const doRequest = boundApiRequest('/api/dict/contact/');

export async function save(data) {
    const { result } = await doRequest('save', data, { blocking: true });
    return result;
}

export async function search(reqt) {
    const { result } = await doRequest('search', reqt);
    return result;
}

export async function remove(id) {
    const { result } = await doRequest('remove', { id });
    return result;
}

export async function load(reqt) {
    const { result } = await doRequest('load', reqt);
    return result;
}

export async function exists(reqt) {
    const { result } = await doRequest('exists', reqt,
    );
    return result;
}

export async function used(id) {
    const { result } = await doRequest('used', { id });
    return result;
}

export async function find(reqt) {
    const { result } = await doRequest('find', reqt);
    return result;
}
